import React, { useMemo } from "react";
import CardGridControl from "./CardGridControl";
import {
  DESTINATION_MANUAL_RUN_AUDIENCE,
  DESTINATION_MANUAL_RUN_WAREHOUSE_MODES
} from "../workspace/resourceWorkspace.destinationUtils";

export const DEFAULT_WAREHOUSE_SYNC_STEP = "PartialWarehouseSync";

export const getWarehouseModeForStep = (step = DEFAULT_WAREHOUSE_SYNC_STEP, modes = DESTINATION_MANUAL_RUN_WAREHOUSE_MODES) => {
  const normalizedStep = String(step || DEFAULT_WAREHOUSE_SYNC_STEP);
  return modes.find((mode) => String(mode.processorStep) === normalizedStep)
    || modes.find((mode) => mode.processorStep === DEFAULT_WAREHOUSE_SYNC_STEP)
    || modes[0]
    || null;
};

export const getWarehouseStepSelectorRows = (modes = DESTINATION_MANUAL_RUN_WAREHOUSE_MODES) =>
  modes.map((mode) => ({
    ModeKey: mode.key,
    StepValue: mode.processorStep,
    DisplayName: mode.label,
    Details: mode.description,
    Impact: mode.audience === DESTINATION_MANUAL_RUN_AUDIENCE.admin ? `${mode.impact} (Admin Only)` : mode.impact,
    SourceMode: mode
  }));

const WarehouseStepSelectorControl = ({
  value = DEFAULT_WAREHOUSE_SYNC_STEP,
  onChange,
  disabled = false,
  className = "",
  modes = DESTINATION_MANUAL_RUN_WAREHOUSE_MODES,
  emptyContent = "No warehouse steps are available.",
  minCardWidth = "15rem",
  maxColumns = 2
}) => {
  const rows = useMemo(() => getWarehouseStepSelectorRows(modes), [modes]);
  const selectedMode = getWarehouseModeForStep(value, modes);
  const selectedKey = selectedMode?.key || "";

  const selectStepByKeys = (nextKeys = []) => {
    const row = rows.find((candidate) => String(candidate.ModeKey) === String(nextKeys[0]));
    if (row) onChange?.(row.StepValue, row.SourceMode);
  };

  return (
    <CardGridControl
      className={className}
      rows={rows}
      cardFields={[
        { FieldName: "DisplayName", DisplayName: "Warehouse Step", ShowOnCard: true },
        { FieldName: "Details", DisplayName: "Description", CardDisplayName: "", ShowOnCard: true },
        { FieldName: "Impact", DisplayName: "Impact", ShowOnCard: true }
      ]}
      rowKey={(row) => row.ModeKey}
      selectedRowKeys={selectedKey ? [selectedKey] : []}
      onSelectedRowKeysChange={selectStepByKeys}
      selectable
      searchable={false}
      activeFilterEnabled={false}
      disabled={disabled}
      emptyContent={emptyContent}
      minCardWidth={minCardWidth}
      maxColumns={maxColumns}
    />
  );
};

export default WarehouseStepSelectorControl;
